(function () {
  "use strict";

  if (!window.DNB) {
    return;
  }

  window.DNB.register(function () {
    if (!window.gsap || !window.ScrollTrigger) {
      return;
    }

    var buildTextOpacityTrigger = function (target, isMobile) {
      var triggerElement =
        target.closest("[data-scroll-section]") || target.closest("section") || target;

      var triggerOptions = {
        trigger: triggerElement,
        start: isMobile ? "top 85%" : "10% bottom",
        end: isMobile ? "bottom 55%" : "top 50%",
        scrub: !isMobile
      };

      if (isMobile) {
        triggerOptions.toggleActions = "play none none reverse";
      }

      if (window.DNB.scroller) {
        triggerOptions.scroller = window.DNB.scroller;
      }

      return triggerOptions;
    };

    var buildTextOpacityV3Trigger = function (target, isMobile) {
      var triggerElement =
        target.closest("[data-scroll-section]") || target.closest("section") || target;

      var triggerOptions = {
        trigger: triggerElement,
        start: isMobile ? "top 88%" : "top 82%",
        toggleActions: "play none none reverse"
      };

      if (window.DNB.scroller) {
        triggerOptions.scroller = window.DNB.scroller;
      }

      return triggerOptions;
    };

    var initTextOpacity = function (scope) {
      var root = scope || document;
      var targets = root.querySelectorAll("[data-text-opacity]");
      if (!targets.length) {
        return;
      }

      var isMobile =
        typeof window.matchMedia === "function" &&
        window.matchMedia("(max-width: 640px)").matches;

      window.gsap.utils.toArray(targets).forEach(function (target) {
        if (target.dataset.textOpacityReady === "true") {
          return;
        }
        target.dataset.textOpacityReady = "true";
        var baseTrigger = buildTextOpacityTrigger(target, isMobile);

        window.gsap.fromTo(
          target,
          { opacity: 0.2 },
          {
            opacity: 1,
            ease: "none",
            duration: isMobile ? 0.6 : 0.1,
            scrollTrigger: baseTrigger
          }
        );
      });
    };

    var initTextOpacityV2 = function (scope) {
      var root = scope || document;
      var v2Targets = root.querySelectorAll("[data-text-opacity-v2]");
      if (!v2Targets.length) {
        return;
      }

      var isMobile =
        typeof window.matchMedia === "function" &&
        window.matchMedia("(max-width: 640px)").matches;

      window.gsap.utils.toArray(v2Targets).forEach(function (target) {
        if (target.dataset.textOpacityV2Ready === "true") {
          return;
        }
        target.dataset.textOpacityV2Ready = "true";
        var triggerOptions = buildTextOpacityTrigger(target, isMobile);

        if (!window.Splitting) {
          window.gsap.fromTo(
            target,
            { opacity: 0.2 },
            {
              opacity: 1,
              ease: "none",
              scrollTrigger: triggerOptions
            }
          );
          return;
        }

        if (!target.hasAttribute("data-splitting")) {
          target.setAttribute("data-splitting", "words");
        }

        window.Splitting({ target: target, by: "words" });

        var words = target.querySelectorAll(".word");
        if (!words.length) {
          return;
        }

        window.gsap.set(words, { opacity: 0.2 });
        window.gsap.to(words, {
          opacity: 1,
          ease: "none",
          duration: isMobile ? 0.6 : 0.1,
          stagger: { each: isMobile ? 0.04 : 0.06, from: "start" },
          scrollTrigger: triggerOptions
        });
      });
    };

    var wrapV3Word = function (word) {
      if (!word || !word.parentNode) {
        return;
      }
      if (
        word.parentNode.classList &&
        word.parentNode.classList.contains("dnb-text-v3-mask")
      ) {
        return;
      }

      var mask = document.createElement("span");
      mask.className = "dnb-text-v3-mask";
      word.parentNode.insertBefore(mask, word);
      mask.appendChild(word);
    };

    var resolveV3Ease = function () {
      if (window.CustomEase && typeof window.CustomEase.create === "function") {
        return window.CustomEase.create(
          "dnbTextOpacityV3Ease",
          "M0,0 C0.625,0.05 0,1 1,1"
        );
      }
      return "power3.out";
    };

    var initTextOpacityV3 = function (scope) {
      var root = scope || document;
      var v3Targets = root.querySelectorAll("[data-text-opacity-v3]");
      if (!v3Targets.length) {
        return;
      }

      var isMobile =
        typeof window.matchMedia === "function" &&
        window.matchMedia("(max-width: 640px)").matches;
      var v3Ease = resolveV3Ease();

      window.gsap.utils.toArray(v3Targets).forEach(function (target) {
        if (target.dataset.textOpacityV3Ready === "true") {
          return;
        }
        target.dataset.textOpacityV3Ready = "true";

        var triggerOptions = buildTextOpacityV3Trigger(target, isMobile);

        if (!window.Splitting) {
          target.setAttribute("data-text-opacity-v3-ready", "true");
          window.gsap.fromTo(
            target,
            { opacity: 0 },
            {
              opacity: 1,
              ease: "power2.out",
              duration: isMobile ? 0.6 : 0.8,
              scrollTrigger: triggerOptions
            }
          );
          return;
        }

        if (!target.hasAttribute("data-splitting")) {
          target.setAttribute("data-splitting", "words");
        }

        window.Splitting({ target: target, by: "words" });

        var words = window.gsap.utils.toArray(target.querySelectorAll(".word"));
        if (!words.length) {
          target.setAttribute("data-text-opacity-v3-ready", "true");
          window.gsap.set(target, { opacity: 1 });
          return;
        }

        words.forEach(wrapV3Word);

        var maskedWords = window.gsap.utils.toArray(
          target.querySelectorAll(".dnb-text-v3-mask .word")
        );
        if (!maskedWords.length) {
          target.setAttribute("data-text-opacity-v3-ready", "true");
          window.gsap.set(target, { opacity: 1 });
          return;
        }

        window.gsap.set(maskedWords, {
          x: 0,
          y: 0,
          yPercent: 110,
          opacity: 1,
          force3D: true
        });

        target.setAttribute("data-text-opacity-v3-ready", "true");
        window.gsap.to(maskedWords, {
          x: 0,
          y: 0,
          yPercent: 0,
          duration: isMobile ? 0.8 : 1,
          ease: v3Ease,
          stagger: {
            each: isMobile ? 0.028 : 0.025,
            from: "start"
          },
          scrollTrigger: triggerOptions
        });
      });
    };

    window.DNB.textOpacityInit = initTextOpacity;
    window.DNB.textOpacityV2Init = initTextOpacityV2;
    window.DNB.textOpacityV3Init = initTextOpacityV3;

    initTextOpacity();
    initTextOpacityV2();
    initTextOpacityV3();
  });
})();
